<div *ngIf='!isMobileView; else mobileView'>
  <ng-template #withRenderer let-column='column' let-element='element'>
    <div [ngClass]='getColumnClass(column, element)'>
      <div [class.left-header]='column.leftAdjusted' [class.text-right]='!column.leftAdjusted'
           [class.text-sm-center]='!column.leftAdjusted' class='element-content flex-grow-1 '>
      <fa-icon class="fa-icon-column-prefix" *ngIf="hasIconPrefix(column, element)" [icon]="getIconPrefix(column, element)"></fa-icon>
      <span
        *ngIf='
          !hasColumnRoute(column) &&
          !hasColumnClickEvent(column) &&
          !column.asHtml
        '
      >{{ column.renderer(element) }}</span
      >
        <span
          *ngIf='
          !hasColumnRoute(column) &&
          !hasColumnClickEvent(column) &&
          column.asHtml
        '
          [innerHtml]='column.renderer(element)'></span>
        <span
          (click)='onColumnClick(column, element)'
          *ngIf='
          !hasColumnRoute(column) &&
          hasColumnClickEvent(column) &&
          !column.asHtml
        '
          class='cursor-pointer'
        >{{ column.renderer(element) }}</span
        >
        <span
          (click)='onColumnClick(column, element)'
          *ngIf='
          !hasColumnRoute(column) &&
          hasColumnClickEvent(column) &&
          column.asHtml
        '
          [innerHtml]='column.renderer(element)'
          class='cursor-pointer'></span>
        <a
          *ngIf='hasColumnRoute(column) && !column.asHtml'
          [routerLink]='getColumnRoute(column, element)'
        >{{ column.renderer(element) }}</a
        >
        <a
          *ngIf='hasColumnRoute(column) && column.asHtml'
          [innerHtml]='column.renderer(element)'
          [routerLink]='getColumnRoute(column, element)'></a>
      </div>
    </div>
  </ng-template>
  <ng-template #withoutRenderer let-column='column' let-element='element'>
    <div [class.left-header]='column.leftAdjusted' [class.text-right]='!column.leftAdjusted'
         [class.text-sm-center]='!column.leftAdjusted' class='element-content flex-grow-1'>
      <ng-container *ngIf="!column.type || column.type === 'text'">
        <ng-container *ngIf='!element[column.id]; else withValue'>
          <span *ngIf='column.emptyValue'>{{ column.emptyValue }}</span>
        </ng-container>
        <ng-template #withValue>
      <span *ngIf='!hasColumnRoute(column) && !hasColumnClickEvent(column)'>{{
          column.isDateColumn && element[column.id]
            ? (element[column.id]
              | timezone: getDateFormat(column) : useSession?.time_zone || null)
            : element[column.id]
        }}</span>
          <span
            (click)='onColumnClick(column, element)'
            *ngIf='!hasColumnRoute(column) && hasColumnClickEvent(column)'
            class='cursor-pointer'
          >{{
              column.isDateColumn
                ? (element[column.id]
                  | timezone: getDateFormat(column) : useSession?.time_zone || null)
                : element[column.id]
            }}</span
          >
          <a
            *ngIf='hasColumnRoute(column)'
            [routerLink]='getColumnRoute(column, element)'
          >{{
              column.isDateColumn
                ? (element[column.id]
                  | timezone: getDateFormat(column) : useSession?.time_zone || null)
                : element[column.id]
            }}</a
          >
        </ng-template>
      </ng-container>
      <ng-container
        *ngIf="
        column.type &&
        column.type === 'button' &&
        (column.getButtonProperties || column.buttonProperties)
      ">
        <app-button
          [Click]='onButtonColumnClick.bind(this, column, element)'
          [color]='getButtonProperties(column, element).color'
          [disabled]='isButtonDisabled(column, element)'
          [initiallyDisabled]='isButtonDisabled(column, element)'
          [loaderObservable]='
          getButtonProperties(column, element).loadingObservable
        '
          [observeApi]='getButtonProperties(column, element).observeApi'
          [route]='getColumnRoute(column, element)'
          [size]='getButtonProperties(column, element).size'
          [style]="'rounded'"
          [text]='getButtonProperties(column, element).text'></app-button>
      </ng-container>
      <ng-container
        *ngIf="
        column.type && column.type === 'select' && column.selectProperties
      ">
        <app-select
          (selection)='onSelectColumnClick(column, $event, element)'
          [confirmMessage]='column.selectProperties.confirmMessage'
          [defaultValue]='getDefaultSelectValue(column, element)'
          [items]='getSelectItems(column, element)'
          [label]='column.selectProperties.label'
          [resetSelection]='column.selectProperties.resetSelection'
          [trackBy]='getTrackBy(column, element)'></app-select>
      </ng-container>
      <ng-container
        *ngIf="
        column.type && column.type === 'checkbox' && column.checkboxProperties
      ">
        <app-checkbox
          (Change)='onCheckboxChange(column, element, $event)'
          (Click)='onCheckboxClick(column, element)'
          [defaultValue]='element[column.id]'
          [disabled]='column.checkboxProperties.disabled'
          [label]='column.checkboxProperties.label'></app-checkbox>
      </ng-container>
      <ng-container
        *ngIf="
        column.type && column.type === 'trigger' && column.triggerProperties
      ">
        <app-trigger
          (Change)='onTriggerColumnChange(column, element, $event)'
          [state]='element[column.id]'></app-trigger>
      </ng-container>
      <ng-container
        *ngIf="
        column.type && column.type === 'component' && column.componentProperties
      ">
        <app-dcl
          [component]='column.componentProperties.component'
          [data]='mapComponentData(column, element)'
          [providers]='dcpProviders'></app-dcl>
      </ng-container>
      <ng-container *ngIf="column.type && column.type === 'anchor'">
        <span (click)='onAnchorClick(column, element)' class='Table__anchor'>{{ element[column.id] }}</span>
      </ng-container>
    </div>
  </ng-template>

  <div class='Table'>
    <div class='Table__filters'>
      <div *ngIf='filters && filters.length > 0' class=''>
        <ng-container *ngFor='let filter of filters'>
          <div
            *ngIf="
            filter.label &&
            filter.type !== 'select' &&
            filter.type !== 'multiselect'
          "
            [ngClass]="{ 'pb-3': filter.type !== 'text' }"
            class="{{
              !filter.size || filter.size === 'full'
                ? 'flex-grow-1'
                : 'flex-grow-0'
            }}">
            <mat-label>{{ filter.label }}</mat-label>
          </div>
          <div *ngIf="filter.type === 'select'" [class.justify-content-end]='filters.length === 1'
               class='d-flex flex-row pb-3' class="{{
              !filter.size || filter.size === 'full'
                ? 'flex-grow-1'
                : 'flex-grow-0'
            }}">
            <app-select
              (selection)='applyFilter(filter, $event)'
              [items]='filter.items'
              [label]='filter.label'></app-select>
            <!--                        <app-table-select-filter [items]="filter.items" [label]="filter.label" (selected)="applyFilter(filter, $event)"></app-table-select-filter>-->
          </div>
          <div *ngIf="filter.type === 'multiselect'" class='d-flex flex-row pb-3'>
            <div class='flex-grow-1'>
              <app-select
                (selection)='applyFilter(filter, $event)'
                [items]='filter.items'
                [label]='filter.label'
                [multi]='true'></app-select>
            </div>
          </div>
          <div *ngIf="filter.type === 'checkbox'" class='d-flex flex-row pb-3'>
            <div *ngFor='let item of filter.items' class='flex-grow-1'>
              <mat-checkbox
                (change)='applyFilter(filter, $event)'
                [attr.data-id]='item.id'
                [value]='item.value'
                class='pe-3'
              >{{ item.label }}
              </mat-checkbox
              >
            </div>
          </div>
          <div *ngIf="filter.type === 'radio'" class='d-flex flex-row pb-3'>
            <mat-radio-group (change)='applyFilter(filter, $event)'>
              <mat-radio-button
                *ngFor='let item of filter.items'
                [attr.data-id]='item.id'
                [checked]='filter.emptyValue === item.value'
                [value]='item.value'
                class='pe-3'
              >{{ item.label }}
              </mat-radio-button
              >
            </mat-radio-group>
          </div>
          <div *ngIf="filter.type === 'text'" class='d-flex flex-row pb-3'>
            <div *ngFor='let item of filter.items' class='flex-grow-1'>
              <app-text-field
                (changes)='applyFilter(filter, $event, item.id)'
                [iconProps]='{ icon: iconSearch, updateOnClick: true }'
                [placeholder]='item.label'
                keyChangesTrigger='Enter'></app-text-field>
            </div>
          </div>
        </ng-container>
      </div>

      <div *ngIf='filterGroups && filterGroups.length > 0' class=''>
        <ng-container *ngFor='let group of filterGroups; let i = index'>
          <mat-label *ngIf='group.label'>{{ group.label }}</mat-label>
          <div class='d-flex flex-column flex-sm-row filter-group align-items-center'>
            <div
              *ngFor='let filter of group.filters'
              class="{{
              !filter.size || filter.size === 'full'
                ? 'flex-grow-1'
                : 'flex-grow-2'
            }} d-flex justify-content-center align-items-center mb-3 mb-sm-0">
              <app-select
                #selectFilters
                (selection)='applyFilter(filter, $event)'
                *ngIf="filter.type === 'select'"
                [defaultValue]='appliedFilters[filter.id]'
                [id]="'filter_' + filter.type + '_' + i"
                [items]='filter.items'
                [label]='filter.label'></app-select>
              <mat-icon
                (click)="resetFilter(filter, 'filter_' + filter.type + '_' + i)"
                *ngIf="
                filter.type === 'select' && appliedFilters[filter.items[0].id]
              "
                class='ms-3 Table__filters__reset-filter'
              >close
              </mat-icon
              >
              <app-select
                (selection)='applyFilter(filter, $event)'
                *ngIf="filter.type === 'multiselect'"
                [items]='filter.items'
                [label]='filter.label'
                [multi]='true'></app-select>
              <div
                *ngIf="filter.type === 'checkbox'"
                class='d-flex flex-row pb-3'>
                <div *ngFor='let item of filter.items' class='flex-grow-1'>
                  <mat-checkbox
                    (change)='applyFilter(filter, $event)'
                    [attr.data-id]='item.id'
                    [value]='item.value'
                    class='pe-3'
                  >{{ item.label }}
                  </mat-checkbox
                  >
                </div>
              </div>
              <div
                *ngIf="filter.type === 'radio'"
                class='d-flex flex-row pb-3 align-items-end'>
                <mat-radio-group (change)='applyFilter(filter, $event)'>
                  <mat-radio-button
                    *ngFor='let item of filter.items'
                    [attr.data-id]='item.id'
                    [checked]='filter.emptyValue === item.value'
                    [value]='item.value'
                    class='pe-3'
                  >{{ item.label }}
                  </mat-radio-button
                  >
                </mat-radio-group>
              </div>
              <div
                *ngIf="filter.type === 'text'"
                class='d-flex flex-row pb-3 align-items-end'>
                <div *ngFor='let item of filter.items' class='flex-grow-1'>
                  <app-text-field
                    (changes)='
                    applyFilter(filter, $event, item.id)
                  '
                    [iconProps]='{ icon: iconSearch, updateOnClick: true }'
                    [placeholder]='item.label'
                    keyChangesTrigger='Enter'></app-text-field>
                </div>
              </div>
              <ng-container *ngIf="filter.type === 'search'">
                <app-table-search-filter
                  (keyup)='appliedFiltersOnEnter(filter, $event, item.id)'
                  (search)='
                  applyFilter(filter, $event, item.id)
                '
                  *ngFor='let item of filter.items; let index'
                  [disabled]='loadingInProgress'

                  [inputValue]='item.value !== undefined ? item.value : appliedFilters[item.id]'
                  [placeholder]='item.label'></app-table-search-filter>
              </ng-container>
              <ng-container *ngIf="filter.type === 'tags'">
                <app-table-tags-filter
                  (search)='applyFilter(filter, $event)'
                  [initialTags]='getSelectedTags(filter.items)' [tags]='filter.items'></app-table-tags-filter>
              </ng-container>
              <ng-container *ngIf="filter.type === 'button'">
                <app-button
                  [Click]='filter.buttonProperties.onClick'
                  [color]='filter.buttonProperties.color'
                  [route]='filter.buttonProperties.route'
                  [size]='filter.buttonProperties.size'
                  [text]='filter.buttonProperties.text'></app-button>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div [class.spinner]='loadingInProgress' class='Table__wrapper'>
      <ng-container *ngIf='loadingInProgress'>
        Loading, please wait...
        <div class='loading-spinner'>
          <mat-spinner></mat-spinner>
        </div>
      </ng-container>
      <div [class.hidden]='dataSource.loading$ | async'>
        <table #table [dataSource]='dataSource' mat-table matSort>
          <ng-container matColumnDef='select'>
            <th *matHeaderCellDef mat-header-cell>
              <mat-checkbox
                (change)='$event ? masterToggle() : null'
                [checked]='selection.hasValue() && isAllSelected()'>
              </mat-checkbox>
            </th>
            <td *matCellDef='let element' mat-cell>
              <mat-checkbox
                (change)='
                isSelected(element)
                  ? delesect(element)
                  : selectElement(element)
              '
                (click)='$event.stopPropagation()'
                [checked]='isSelected(element)'>
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container
            *ngFor='let column of getColumns(); let idx = index'
            matColumnDef='{{ column.id }}'>
            <ng-container *ngIf='column.sortable; else notSortable'>
              <th *matHeaderCellDef [class.left-header]='column.leftAdjusted' disableClear mat-header-cell
                  mat-sort-header>
                {{ column.title }}
                <app-svg-renderer
                  (click)='openHintDialog(column.hint)'
                  *ngIf='column.hint'
                  [svg]="'Yellow Plane'"></app-svg-renderer>
              </th>
              <td *matCellDef='let row' [class.left-header]='column.leftAdjusted' mat-cell>
                <ng-container
                  [ngTemplateOutletContext]='{
                  element: row,
                  column: column
                }'
                  [ngTemplateOutlet]='
                  column.renderer ? withRenderer : withoutRenderer
                '></ng-container>
              </td>
            </ng-container>
            <ng-template #notSortable>
              <ng-container
                *ngIf='
                !column.headerAsFilter && !column.headerAsPagination;
                else filterColumn
              '>
                <th *matHeaderCellDef [class.left-header]='column.leftAdjusted' mat-header-cell>
                  {{
                    column.title
                  }}
                  <app-svg-renderer
                    (click)='openHintDialog(column.hint)'
                    *ngIf='column.hint'
                    [svg]="'Yellow Plane'"></app-svg-renderer>
                </th>
              </ng-container>
              <ng-template #filterColumn>
                <ng-container
                  *ngIf='!column.headerAsPagination; else paginationColumn'>
                  <th *matHeaderCellDef mat-header-cell>
                    <select
                      (change)='applyFilterColumn($event, column)'
                      *ngIf='column.selectProperties'
                      class='Table__wrapper__header-select'>
                      <option
                        *ngFor='let item of column.selectProperties.items'
                        [selected]='item.selected' [value]='item.value'>
                        {{ item.label }}
                      </option>
                    </select>
                  </th>
                </ng-container>
                <ng-template #paginationColumn>
                  <th *matHeaderCellDef mat-header-cell>
                    <select
                      (change)='applyPagination($event)'
                      class='Table__wrapper__header-select'>
                      <option
                        *ngFor='let item of getPaginationOptions()'
                        [value]='item'>
                        {{ item }}
                      </option>
                    </select>
                  </th>
                </ng-template>
              </ng-template>
              <td
                *matCellDef='let row'
                [class.left-header]='column.leftAdjusted'
                [colSpan]='column.isExtra ? getColumns().length + 1 : 1'
                mat-cell>
                <ng-container
                  [ngTemplateOutletContext]='{
                  element: row,
                  column: column
                }'
                  [ngTemplateOutlet]='
                  column.renderer ? withRenderer : withoutRenderer
                '></ng-container>
              </td>
            </ng-template>
          </ng-container>

          <tr *matHeaderRowDef='getDisplayedColumns()' mat-header-row></tr>
          <tr
            *matRowDef='let row; columns: getDisplayedColumns()'
            [ngClass]='getRowClass(row)'
            [popoverOnHover]='hasRowPopover(row)'
            [popoverPlacement]="'top-left'"
            [popover]='getRowPopover(row)'
            mat-row></tr>
          <tr *matNoDataRow class='mat-row'>
            <td *ngIf='itemsCollected' [attr.colspan]='getDisplayedColumns().length' class='mat-cell text-center'>
              {{ emptyDataText }}
            </td>
          </tr>
          <ng-container *ngIf='hasExtraColumn()'>
            <tr
              *matRowDef='
              let row;
              columns: [getExtraColumnName()];
              when: isExpansionDetailRow
            '
              [ngClass]='getRowClass(row)'
              mat-row></tr>
          </ng-container>
        </table>
      </div>
    </div>
    <div
      [class.hidden]='dataSource.loading$ | async'
      class='d-flex flex-row Table__footer'>
      <div class='flex-grow-1'>
        <app-paginator
          #paginatorComponent
          *ngIf='showPagination'
          [currentPage]='currentPage'
          [length]='dataSource.totalPages'
          [pageSizeOptions]='[10, 20, 50, 100]'
          [pageSize]='currentPageSize'
          [showFirstLastButtons]='true'
          [showItemsPerPage]='shouldShowItemsPerPage()'
          [showPrevNextButtons]='true'
          [totalCount]='dataSource.totalCount'></app-paginator>
      </div>
      <div
        *ngIf='
        selection.selected.length > 0 &&
        massiveActions &&
        massiveActions.length > 0
      '
        class='Table-massive-actions flex-grow-0 d-flex align-items-center'>
        <app-select
          (selection)='onMassiveAction($event)'
          [items]='getMassiveActionItems()'
          label='On selected'></app-select>
      </div>
    </div>
  </div>
</div>
<ng-template #mobileView>
  <ng-container *ngIf='mobileRows; else noRows'>
    <div *ngIf='filters && filters.length > 0' class=''>
      <ng-container *ngFor='let filter of filters'>
        <div
          *ngIf="
            filter.label &&
            filter.type !== 'select' &&
            filter.type !== 'multiselect'
          "
          [ngClass]="{ 'pb-3': filter.type !== 'text' }"
          class="{{
              !filter.size || filter.size === 'full'
                ? 'flex-grow-1'
                : 'flex-grow-0'
            }}">
          <mat-label>{{ filter.label }}</mat-label>
        </div>
        <div *ngIf="filter.type === 'select'" [class.justify-content-end]='filters.length === 1'
             class='d-flex flex-row pb-3' class="{{
              !filter.size || filter.size === 'full'
                ? 'flex-grow-1'
                : 'flex-grow-0'
            }}">
          <app-select
            (selection)='applyFilter(filter, $event)'
            [defaultValue]='filter[filter.label]'
            [items]='filter.items'
            [label]='filter.label'></app-select>
          <!--                        <app-table-select-filter [items]="filter.items" [label]="filter.label" (selected)="applyFilter(filter, $event)"></app-table-select-filter>-->
        </div>
        <div *ngIf="filter.type === 'multiselect'" class='d-flex flex-row pb-3'>
          <div class='flex-grow-1'>
            <app-select
              (selection)='applyFilter(filter, $event)'
              [items]='filter.items'
              [label]='filter.label'
              [multi]='true'></app-select>
          </div>
        </div>
        <div *ngIf="filter.type === 'checkbox'" class='d-flex flex-row pb-3'>
          <div *ngFor='let item of filter.items' class='flex-grow-1'>
            <mat-checkbox
              (change)='applyFilter(filter, $event)'
              [attr.data-id]='item.id'
              [value]='item.value'
              class='pe-3'
            >{{ item.label }}
            </mat-checkbox
            >
          </div>
        </div>
        <div *ngIf="filter.type === 'radio'" class='d-flex flex-row pb-3'>
          <mat-radio-group (change)='applyFilter(filter, $event)'>
            <mat-radio-button
              *ngFor='let item of filter.items'
              [attr.data-id]='item.id'
              [checked]='filter.emptyValue === item.value'
              [value]='item.value'
              class='pe-3'
            >{{ item.label }}
            </mat-radio-button
            >
          </mat-radio-group>
        </div>
        <div *ngIf="filter.type === 'text'" class='d-flex flex-row pb-3'>
          <div *ngFor='let item of filter.items' class='flex-grow-1'>
            <app-text-field
              (changes)='applyFilter(filter, $event, item.id)'
              [iconProps]='{ icon: iconSearch, updateOnClick: true }'
              [placeholder]='item.label'
              keyChangesTrigger='Enter'></app-text-field>
          </div>
        </div>
      </ng-container>
    </div>
    <div *ngIf='filterGroups && filterGroups.length > 0' class='mb-3'>
      <ng-container *ngFor='let group of filterGroups; let i = index'>
        <mat-label *ngIf='group.label'>{{ group.label }}</mat-label>
        <div class='d-flex flex-column filter-group align-items-start'>
          <div
            *ngFor='let filter of getSearchFilters(group.filters)'
            [class.d-none]='filter.hideOnMobile' class="{{
              !filter.size || filter.size === 'full'
                ? 'flex-grow-1'
                : 'flex-grow-2'
            }} d-flex justify-content-between align-items-center mt-1">
            <ng-container *ngIf="filter.type === 'search'">
              <app-table-search-filter
                (keyup)='appliedFiltersOnEnter(filter, $event, item.id)'
                (search)='
                  applyFilter(filter, $event, item.id)
                '
                *ngFor='let item of filter.items; let index'

                [inputValue]='appliedFilters[item.id]'
                [placeholder]='item.label'></app-table-search-filter>
            </ng-container>
          </div>
        </div>
        <div class='d-flex flex-row filter-group align-items-start justify-content-between'>
          <div
            *ngFor='let filter of getNotSearchFilters(group.filters)'
            [class.d-none]='filter.hideOnMobile' class='mt-3'>
            <app-select
              #selectFilters
              (selection)='applyFilter(filter, $event)'
              *ngIf="filter.type === 'select'"
              [defaultValue]='appliedFilters[filter.id]'
              [id]="'filter_' + filter.type + '_' + i"
              [items]='filter.items'
              [label]='filter.label'></app-select>
            <mat-icon
              (click)="resetFilter(filter, 'filter_' + filter.type + '_' + i)"
              *ngIf="
                filter.type === 'select' && appliedFilters[filter.items[0].id]
              "
              class='ms-3 Table__filters__reset-filter'
            >close
            </mat-icon
            >
            <app-select
              (selection)='applyFilter(filter, $event)'
              *ngIf="filter.type === 'multiselect'"
              [items]='filter.items'
              [label]='filter.label'
              [multi]='true'></app-select>
            <div
              *ngIf="filter.type === 'checkbox'"
              class='d-flex flex-row pb-3'>
              <div *ngFor='let item of filter.items' class='flex-grow-1'>
                <mat-checkbox
                  (change)='applyFilter(filter, $event)'
                  [attr.data-id]='item.id'
                  [value]='item.value'
                  class='pe-3'
                >{{ item.label }}
                </mat-checkbox
                >
              </div>
            </div>
            <div
              *ngIf="filter.type === 'radio'"
              class='d-flex flex-row pb-3 align-items-end'>
              <mat-radio-group (change)='applyFilter(filter, $event)'>
                <mat-radio-button
                  *ngFor='let item of filter.items'
                  [attr.data-id]='item.id'
                  [checked]='filter.emptyValue === item.value'
                  [value]='item.value'
                  class='pe-3'
                >{{ item.label }}
                </mat-radio-button
                >
              </mat-radio-group>
            </div>
            <div
              *ngIf="filter.type === 'text'"
              class='d-flex flex-row pb-3 align-items-end'>
              <div *ngFor='let item of filter.items' class='flex-grow-1'>
                <app-text-field
                  (changes)='
                    applyFilter(filter, $event, item.id)
                  '
                  [iconProps]='{ icon: iconSearch, updateOnClick: true }'
                  [placeholder]='item.label'
                  keyChangesTrigger='Enter'></app-text-field>
              </div>
            </div>
            <ng-container *ngIf="filter.type === 'search'">
              <app-table-search-filter
                (keyup)='appliedFiltersOnEnter(filter, $event, item.id)'
                (search)='
                  applyFilter(filter, $event, item.id)
                '
                *ngFor='let item of filter.items; let index'

                [inputValue]='appliedFilters[item.id]'
                [placeholder]='item.label'></app-table-search-filter>
            </ng-container>
            <ng-container *ngIf="filter.type === 'tags'">
              <app-table-tags-filter
                (search)='applyFilter(filter, $event)'
                [tags]='filter.items'></app-table-tags-filter>
            </ng-container>
            <ng-container *ngIf="filter.type === 'button'">
              <app-button
                [Click]='filter.buttonProperties.onClick'
                [color]='filter.buttonProperties.color'
                [route]='filter.buttonProperties.route'
                [size]='filter.buttonProperties.size'
                [text]='filter.buttonProperties.text'></app-button>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf='!mobileData.length'><p>{{ emptyDataText }}</p></ng-container>
    <div *ngFor='let data of mobileData'>
      <ng-container *ngTemplateOutlet='mobileRows.templateRef;context:{row: data,currentUser: useSession}'>
      </ng-container>
    </div>
    <div *ngIf='lazyLoadNextPageInProgress' class='d-flex justify-content-center'>
      <mat-spinner [diameter]='40'></mat-spinner>
    </div>
    <div #lazyLoadingBorder class='Table__lazy-loading-border'></div>
  </ng-container>
  <ng-template #noRows>{{ emptyDataText }}</ng-template>
</ng-template>
